import React from "react";
import { branch } from "baobab-react/higher-order";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Flexbox from "flexbox-react";
import { DropdownButton, MenuItem } from "react-bootstrap";

import MultiSelectToolbar from "./app-multiselect-toolbar";

import { selectAllStatusItems, resetSelectedStatusItems } from "../../actions/statusActions";
import { getOrgId } from "../../actions/orgsActions";
import { isOrganizationAdministrator, isOrganizationEmployeeInternal, isOrganizationUser } from "../../actions/user";

const JAB_CC_ORG_ID = "332a9d47-6e36-11e8-a392-061714f61e3e";

class MultiSelectStatusToolbar extends React.PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			selectingAll: false
		};
	}

	async handleSelectAllStatusResults() {
		if (this.state.selectingAll) {
			return;
		}

		if (!window.globalSearchHistoryView || typeof window.globalSearchHistoryView.selectAllFilteredStatusItems !== "function") {
			this.props.dispatch(
				selectAllStatusItems
			);
			return;
		}

		this.setState({ selectingAll: true });
		try {
			await window.globalSearchHistoryView.selectAllFilteredStatusItems();
		} finally {
			this.setState({ selectingAll: false });
		}
	}

	render() {
		const orgId = getOrgId();
		const isAdmin = isOrganizationAdministrator();
		const selectionActionBusy = this.state.selectingAll;
		const isJabCcInternalUser = orgId === JAB_CC_ORG_ID && isOrganizationUser() && isOrganizationEmployeeInternal();
		const canBulkWorkflow = !selectionActionBusy && orgId === JAB_CC_ORG_ID && (isAdmin || isJabCcInternalUser);
		const canBulkPrint = isAdmin && !selectionActionBusy;
		const canPrintInvoices = isAdmin && orgId === JAB_CC_ORG_ID;
		const canBulkDelete = isAdmin && !selectionActionBusy;
		let multiSelectToolbar =
			<MultiSelectToolbar
				selectedItems={this.props.selectedStatusItems}
				showSelectAll={isAdmin && !this.props.statusSelectionBatchMode}
				selectAllLabel={this.state.selectingAll ? "Selecting..." : "Select All"}
				showSelectPage={isAdmin && !this.props.statusSelectionBatchMode && !selectionActionBusy}
				selectPageLabel="Select Page"
				closeDisabled={selectionActionBusy}
				onClickClose={() => {
					this.props.dispatch(
						resetSelectedStatusItems
					);
				}}
				onClickSelectAll={() => {
					this.handleSelectAllStatusResults();
				}}
				onClickSelectPage={() => {
					this.props.dispatch(
						selectAllStatusItems
					);
				}}>
				<Flexbox flexDirection="row" alignItems="center">
					{canBulkPrint &&
						<div className="multiSelectStatusPrintAction" style={{ marginRight: "18px" }}>
							<DropdownButton
								id="selected-status-print-menu"
								title={<span><FontAwesomeIcon icon="print" /> <span className="multiSelectStatusPrintLabel" style={{ fontSize: "15px" }}>Print</span></span>}
								bsStyle="link"
								pullRight
								aria-label="Print selected items"
							>
								{canPrintInvoices &&
									<MenuItem eventKey="invoice" onClick={(e) => {
										e.stopPropagation();
										if (window.globalSearchHistoryView) {
											window.globalSearchHistoryView.openInvoiceReportModal();
										}
									}}>
										<FontAwesomeIcon icon="file-invoice-dollar" /> Print Invoices Report
									</MenuItem>
								}
								<MenuItem eventKey="activity" onClick={(e) => {
									e.stopPropagation();
									if (window.globalSearchHistoryView) {
										window.globalSearchHistoryView.printSelectedActivityReport();
									}
								}}>
									<FontAwesomeIcon icon="print" /> Print Activities Report
								</MenuItem>
								<MenuItem eventKey="completion" onClick={(e) => {
									e.stopPropagation();
									if (window.globalSearchHistoryView) {
										window.globalSearchHistoryView.printSelectedCompletionReport();
									}
								}}>
									<FontAwesomeIcon icon="check-square" /> Print Completion Report
								</MenuItem>
							</DropdownButton>
						</div>
					}
					{canBulkWorkflow &&
						<button type="button" className="multiSelectStatusWorkflowAction" aria-label="Update workflow status for selected items" title="Update workflow status" style={{ marginRight: "25px", cursor: "pointer" }} onClick={() => {
							window.globalSearchHistoryView.setWorkflowStatuses();
						}}>
							<FontAwesomeIcon icon="users-cog" />
						</button>
					}
					{canBulkDelete &&
						<button type="button" className="multiSelectStatusDeleteAction" aria-label="Delete selected items" title="Delete selected items" style={{ cursor: "pointer" }} onClick={() => {
							window.globalSearchHistoryView.deleteInstances();
						}}>
							<FontAwesomeIcon icon="trash" />
						</button>
					}
				</Flexbox>
			</MultiSelectToolbar>;

		if (this.props.selectedStatusItems.length === 0) {
			multiSelectToolbar = null;
		}

		return multiSelectToolbar;
	}
}

export default branch({
	selectedStatusItems: ["appState", "selectedStatusItems"],
	statusSelectionBatchMode: ["appState", "statusSelectionBatchMode"],
}, MultiSelectStatusToolbar);
